export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center" style={{ backgroundColor: '#1a1e1a' }}>
      {/* Logo with glow and pulse animation */}
      <div className="mb-12 relative">
        {/* Glowing background layer */}
        <div className="absolute inset-0 blur-2xl opacity-50 animate-pulse">
          <img 
            src="/logos/logo-color-textunder.svg" 
            alt=""
            className="h-48 w-auto"
          />
        </div>
        {/* Main logo */}
        <img 
          src="/logos/logo-color-textunder.svg" 
          alt="Beredskapshubben" 
          className="relative h-48 w-auto animate-pulse"
        />
      </div>
      
      {/* Animated Loading Ring */}
      <div className="relative">
        {/* Outer glow ring */}
        <div className="absolute inset-0 animate-pulse">
          <svg className="h-12 w-12" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#ff8c42"
              strokeWidth="2"
              opacity="0.2"
            />
          </svg>
        </div>
        
        {/* Spinning donut */}
        <svg className="h-12 w-12 animate-spin" viewBox="0 0 100 100">
          <defs>
            <linearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#ff8c42" stopOpacity="1" />
              <stop offset="50%" stopColor="#ffa366" stopOpacity="1" />
              <stop offset="100%" stopColor="#ff8c42" stopOpacity="0.3" />
            </linearGradient>
            <filter id="glow">
              <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke="url(#spinnerGradient)"
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray="220 70"
            filter="url(#glow)"
            style={{
              transformOrigin: 'center',
            }}
          />
        </svg>
      </div>
      
      {/* Loading text */}
      <p className="mt-8 text-sm text-gray-400 animate-pulse">
        Laddar...
      </p>
    </div>
  );
}
